import TwoNongMarket from './TwoNongMarket';
export default TwoNongMarket;
